import React from "react";
import { Box, Typography } from "@mui/material";
import { useIntl } from "react-intl";

export default function OperationProjectListPage() {
  const intl = useIntl();
  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>
        {intl.formatMessage({ id: "menu.projects" })}
      </Typography>
      {/* TODO: プロジェクト一覧の実装 */}
    </Box>
  );
}
